import { gtmEventType } from '@Components/Utilities/SandhillsConstants';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import TextField from '@mui/material/TextField';
import { forwardRef, useEffect, useImperativeHandle } from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';

const GoogleAutoComplete = forwardRef((props, placesRef) => {

    const {
        id,
        name,
        apiKey,
        value,
        required,
        fullWidth,
        size,
        variant,
        label,
        helperText,
        onChange,
        onPlaceChange,
        onBlur
    } = props;

    const { ref } = usePlacesWidget({
        apiKey: apiKey,
        onPlaceSelected: (place) => {
            let address1 = '', postalCode = '', city = '', state = '', stateTyped = '', country = '';
            for (const component of place.address_components) {
                const componentType = component.types[0];
                switch (componentType) {
                    case 'street_number':
                        address1 = component.long_name;
                        break;
                    case 'route':
                        address1 += ' ' + component.short_name;
                        break;
                    case 'postal_code':
                        postalCode = component.long_name;
                        break;
                    case 'locality':
                        city = component.long_name;
                        break;
                    case 'postal_town':
                        city = component.long_name;
                        break;
                    case 'administrative_area_level_1':
                        state = component.short_name;
                        stateTyped = component.long_name;
                        break;
                    case 'country':
                        if (component.short_name == 'US') country = 'USA'
                        else country = component.long_name;
                        break;
                }
            }

            gtmPushEvent(gtmEventType.googlePlaceSelected);
            onPlaceChange?.({
                Address1: address1 || '',
                City: city || '',
                State: state || '',
                StateTyped: stateTyped || '',
                PostalCode: postalCode || '',
                Country: country || ''
            });
        },
        options: {
            types: ['address'],
            fields: ['address_components']
        }
    });

    useImperativeHandle(placesRef, () => ({
        focus: () => {
            ref.current?.focus?.();
        }
    }));

    useEffect(() => {
        window.gm_authFailure = () => {
            document.getElementById('Address1').disabled = false;
            document.getElementById('Address1').placeholder = '';
            document.getElementById('Address1').style.backgroundImage = '';
        };
    }, []);

    return (
        <TextField
            id={id}
            required={required}
            fullWidth={fullWidth}
            size={size}
            name={name}
            variant={variant}
            value={value}
            label={label}
            error={helperText ? true : false}
            helperText={helperText}
            inputRef={ref}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
});

export default GoogleAutoComplete;